module.exports = __webpack_public_path__ + "img/Flaticon.ccf47359.svg";